module.exports = __webpack_public_path__ + "img/Cloud.53fcdd0d.svg";